import React from 'react'

const WhatsAppFloat = () => {
  return (
    <a
      href="https://wa.me/5567981414278"
      className="whatsapp-float"
      target="_blank"
      rel="noreferrer"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  )
}

export default WhatsAppFloat
